 <div class="login-clean m-auto container">

  <div class="col-sm-12 text-center mt-2">
    <img src="../assets//img/2000px-Vodafone_icon.svg.png"
    alt="Vodafone"
    style="height: 60px;margin-right: 10px;cursor: pointer;">
    VMS
  </div>


  <div class="row">
    <div class="col-sm-12" *ngIf="this.router.url=='/admin-login'">
      <form class="text-center border rounded shadow-lg" [formGroup]="form" (ngSubmit)="onSubmit()">
        <h1 class="text-red">
          <img src="../assets//img/2000px-Vodafone_icon.svg.png" alt="Vodafone" style="height: 40px;">
          VMS Login
        </h1>
        <h2 class="sr-only">Login Form</h2>

        <div class="form-group shadow-lg " >

        <div class="input-group mb-3" >

          <input type="text" formControlName="user_email" class="form-control" placeholder="Username" aria-label="Username"
                 aria-describedby="basic-addon1">

        </div>
        </div>

        <div class="form-group">
          <input formControlName="user_password" class="form-control" type="password" name="password"
                                       required=""
                                       placeholder="Password" id="password" style="margin-left: -15px;;">
          <i class="fa fa-eye-slash" id="togglePassword"
           (mousedown)="toggelVisibility($event)"  (mouseup)="visibilityOff()"></i>
          </div>


        <div [hidden]="!auth_ui_res" class="ui message {{auth_ui_class}} text-black-50">
          <div class="header" [style.color]="auth_ui_class">
            {{auth_ui_msg}}
          </div>
          <p [style.color]="auth_ui_class">{{auth_ui_process}}</p>
        </div>
        <div class="form-group">
          <button [disabled]="!form.valid"
                  class="btn btn-danger text-center border rounded shadow-sm d-lg-flex justify-content-lg-center"
                  type="submit" data-bs-hover-animate="pulse"
                  style="width: 323px;padding: 6px;background-color: rgb(231,0,0);margin: 7px;">Submit
          </button>
        </div>

      </form>
    </div>
  </div>



  <div class="col-sm-12 text-center mt-2" *ngIf="this.router.url=='/admin-login'">
      <button  mat-raised-button  color="primary" (click)="goToSSO()">
        <span style="margin: 0px;padding: 0px;" >SSO Login</span>
      </button>
  </div>
</div> -->






